function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
export class FormResponseDraft {
    constructor(resp){
        _define_property(this, "response", void 0);
        _define_property(this, "timestamp", void 0);
        _define_property(this, "formInstance", void 0);
        this.response = resp.response;
        this.timestamp = resp.timestamp;
        this.formInstance = resp.formInstance;
    }
}
